module.exports = __webpack_public_path__ + "static/media/image-6-1024x597.0a067ec0.png";